import { TVillageOffersType } from '../constants/base';
import { IState } from '../store';

export function getVillageOffersType(state: IState): TVillageOffersType | undefined {
  const { builderCounterSet = {}, resaleCounterSet = {} } = state.villageData.village || {};

  if (builderCounterSet.total && resaleCounterSet.total) {
    return 'resaleAndBuilder';
  }

  if (builderCounterSet.total) {
    return 'builder';
  }
  if (resaleCounterSet.total) {
    return 'resale';
  }

  return undefined;
}
